<script setup>
import { ref, reactive } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "@/stores/storeFieldData";
import BasePictureCropper from "@/components/ui/BasePictureCropper.vue";
import ProfileFormRegistration from "@/components/profile/ProfileFormRegistration.vue";

const storeRequests = useRequestsStore();
const storeField = useFieldsStore();

const userDataApplication = reactive({
	photo: storeField.fields.photoUser,
	isPicAdd: false,
})

</script>

<template>
	<section class="registration">		
		<div class="registration__container reg-container">
			<div class="registration__image">
				<BasePictureCropper :is-cook-photo="true" :cropWidth="310" :cropHeight="310" v-model:photo="storeField.fields.photoUser" :userApplication="userDataApplication"/>
			</div>
			<div class="registration__form">
				<ProfileFormRegistration />					
			</div>
		</div>		
	</section>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.registration {
	width: 100%;
}

.registration__header {
}
.registration__title {
}

.registration__subtitle {
}
.registration__container {
	width: 100%;
	display: grid;
	grid-template-columns: 33.8rem 1fr;
	gap: 2rem;
	align-items: start;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
		justify-items: center;
	}
}
.registration__image {
	@media (max-width: vars.$m) {
		width: 33.8rem;
	}
	@media (max-width: vars.$x425) {
		width: 100%;
	}
}
.registration__form {
	width: 100%;
}
</style>
